/* eslint-disable react/prop-types */
// Argon Dashboard 2 MUI components
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonAvatar from "components/ArgonAvatar";
import ArgonBadge from "components/ArgonBadge";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";

// Images
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import team4 from "assets/images/team-4.jpg";

function Author({ image, name, email }) {
  return (
    <ArgonBox display="flex" alignItems="center" px={0.5} py={0.1}>
      <ArgonBox mr={2}>
        <ArgonAvatar src={image} alt={name} size="sm" variant="rounded" />
      </ArgonBox>
      <ArgonBox display="flex" flexDirection="column">
        <ArgonTypography textTransform="none" variant="button" fontWeight="medium">
          {name}
        </ArgonTypography>
        <ArgonTypography variant="caption" color="secondary">
          {email}
        </ArgonTypography>
      </ArgonBox>
    </ArgonBox>
  );
}

function Function({ job, org }) {
  return (
    <ArgonBox display="flex" flexDirection="column">
      <ArgonTypography variant="caption" fontWeight="medium" color="text">
        {job}
      </ArgonTypography>
      <ArgonTypography variant="caption" color="secondary">
        {org}
      </ArgonTypography>
    </ArgonBox>
  );
}

const authorsTableData = (leaderBoardData = []) => {
  const columns = [
    { name: "sno", align: "center" },
    { name: "Leader1", align: "left" },
    { name: "Leader2", align: "left" },
    { name: "Leader3", align: "left" },
    { name: "Month", align: "center" },
  ];

  const rows = leaderBoardData.map((item, index) => ({
    sno: (
      <ArgonTypography variant="caption" fontWeight="medium" color="text">
        {index + 1}
      </ArgonTypography>
    ),
    Leader1: (
      <Author
        image={item.leader1?.profileImage}
        name={item.leader1?.fullName || "N/A"}
        email={item.leader1?.email || "N/A"}
      />
    ),
    Leader2: (
      <Author
        image={item.leader2?.profileImage}
        name={item.leader2?.fullName || "N/A"}
        email={item.leader2?.email || "N/A"}
      />
    ),
    Leader3: (
      <Author
        image={item.leader3?.profileImage}
        name={item.leader3?.fullName || "N/A"}
        email={item.leader3?.email || "N/A"}
      />
    ),
    Month: (
      <ArgonTypography variant="caption" fontWeight="medium" color="text">
        {item.month} {item.year}
      </ArgonTypography>
    ),
  }));

  return { columns, rows };
};

export default authorsTableData;
//     {
